import { useState } from 'react';
import { Pane } from 'evergreen-ui';
import { useMutation } from 'react-query';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';
import { updateUser } from '../../store/authSlice';
import { updateSettings } from '../../queries/settings';
import getUserRequest from '../../queries/getUser';
import SlideToStart from '../../components/shikky/components/SlideToStart';
import StartLoader from '../../components/shikky/components/StartLoader';
import ShiftsList from '../../components/shikky/components/ShiftsList';
import { LOADER_PHASES } from '../../components/shikky/utils';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const PanelShifts = ({ settings, user, selectedTab, setSelectedTab, shifts, refetchSettings }) => {
  const [loading, setLoading] = useState(settings?.enabled);
  const [enabled, setEnabled] = useState(settings?.enabled);
  const [statusText, setStatusText] = useState(
    settings?.enabled ? LOADER_PHASES.SEARCHING : LOADER_PHASES.READY_TO_SEARCH,
  );
  const dispatch = useDispatch();
  const token = useSelector(state => state.authentication.token);
  const navigate = useNavigate();
  const onSlided = () => {
    if (user.unauthorized) {
      navigate('/app/accountRelinking');
    } else {
      if (settings?.hasAPaidSubscription) {
        setLoading(true);
        setStatusText(LOADER_PHASES.INITIATING);
        init();
      } else {
        setSelectedTab(1);
      }
    }
  };
  const getUserQuery = useMutation(getUserRequest, {
    useErrorBoundary: true,
    onSuccess: async data => {
      console.log(data);
    },
  });

  useEffect(() => {
    const f = async () => {
      const res = await getUserQuery.mutateAsync({ token });
      // console.log('res', res);
      if (user?.unauthorized !== res.unauthorized) dispatch(updateUser(res));
    };
    f();
    const intervalId = setInterval(f, 10000);
    return () => clearInterval(intervalId);
  }, []);

  const updateSettingsQuery = useMutation(updateSettings, {
    useErrorBoundary: true,
  });
  const toggleEnabled = async e => {
    await updateSettingsQuery.mutateAsync({
      enabled: e,
      dayFilters: settings?.dayFilters ?? [],
      token,
    });
    await refetchSettings();
  };

  const init = async () => {
    await toggleEnabled(true);
    setEnabled(true);
    setStatusText(LOADER_PHASES.SEARCHING);
  };

  const pause = async () => {
    await toggleEnabled(false);
    setEnabled(false);
    setLoading(false);
    setStatusText(LOADER_PHASES.READY_TO_SEARCH);
  };

  const toggleSearch = () => {
    if (user.unauthorized) {
      navigate('/app/accountRelinking');
    } else {
      if (settings?.hasAPaidSubscription) {
        if (enabled) {
          pause();
        } else {
          setLoading(true);
          setStatusText(LOADER_PHASES.INITIATING);
          init();
        }
      } else {
        setSelectedTab(1);
      }
    }
  };
  // upcoming shifts
  const NOW = moment();
  const filteredItems =
    shifts &&
    shifts.filter(item => {
      const theMomentTheShiftWasCreated = moment(item.created_at);
      return theMomentTheShiftWasCreated.isAfter(NOW) && theMomentTheShiftWasCreated.isBefore(NOW.add(24, 'hours'));
    });

  const isLinked = !user.unauthorized;

  return (
    <Pane display="flex" flexDirection="column" height="100%">
      {filteredItems?.length > 0 ? (
        <ShiftsList
          items={filteredItems}
          loading={loading}
          phase={isLinked ? statusText : 'DISCONNECTED'}
          toggleSearch={toggleSearch}
          isLinked={isLinked}
        />
      ) : (
        <>
          <Pane display="flex" justifyContent="center" alignItems="center" flexGrow={1} paddingBottom={100}>
            <StartLoader loading={loading} statusText={isLinked ? statusText : 'DISCONNECTED'} />
          </Pane>
          <Pane
            display="flex"
            justifyContent="center"
            alignItems="center"
            position="fixed"
            left={0}
            bottom={110}
            right={0}
          >
            <SlideToStart
              onSlided={onSlided}
              searching={enabled}
              onPause={pause}
              selectedTab={selectedTab}
              isLinked={isLinked}
            />
          </Pane>
        </>
      )}
    </Pane>
  );
};

export default PanelShifts;
